import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import SiteRow from './SiteRow';
import { getSites } from '../../actions/sites';

class SiteList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    getSites().finally(() => {
      this.setState({ loading: false });
    });
  }

  renderSites = (sites) => {
    if (sites && sites.formulary) {
      return sites.formulary.map((site) => <SiteRow site={{ site }} key={{ site }} />);
    }

    return (
      <tr>
        <td className="text-center py-2" colSpan={6}>Something went wrong.</td>
      </tr>
    );
  };

  render() {
    const { loading } = this.state;
    const { sites } = this.props;
    return (
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="13">
              <div className="m-4 text-center">
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
                <Spinner style={{ width: '5rem', height: '5rem' }} type="grow" color="info" />
              </div>
            </td>
          </tr>
        ) : (
          this.renderSites(sites)
        )}
      </tbody>
    );
  }
}

const mapStateToProps = (store) => ({
  sites: store.sites.formularySites,
});

export default connect(mapStateToProps)(SiteList);
